import React, { useEffect, useState } from "react";
import axios from "../../Utils/Axios";
import LoadingOverlay from "react-loading-overlay-ts";
import { useHistory } from "react-router-dom";
import Breadcrumbs from '@mui/material/Breadcrumbs';
import BLink from '@mui/material/Link';
import { useAlert } from "react-alert";
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import { ErrorHandler } from "../../ui/ErrorHandler";
import TextEditor from "../../ui/TextEditor";
import "./Portfolio.css";
import SelectSearch from 'react-select-search';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import Seo from "../Seo/Seo";
const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});
function EditPortfolio(props) {

    const alert = useAlert();
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const [portfolio, setPortfolio] = useState({});
    const [services, setServices] = useState([]);
    const [image, setImage] = useState(null);
    const [imageAr, setImageAr] = useState(null);
    const [portfolioId, setPortfolioId] = useState(
        props.match && props.match.params && props.match.params.id
            ? props.match.params.id
            : ""
    );


    useEffect(() => {
        getPortfolioDetails();
        getServices();
    }, [props.match.params.id]);
    const getPortfolioDetails = () => {
        axios(`admin/portfolio/${props.match.params.id}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                Authorization: "Bearer " + JSON.parse(localStorage.getItem("data")),
            },
        })
            .then((response) => {
                if (response.status === 200) {
                    setPortfolio(response.data.data.portfolio);
                } else {
                    setLoading(false);
                    ErrorHandler(alert, response.status, response.data.message)
                }
            })
            .catch(({ response }) => {
                setLoading(false);
                ErrorHandler(alert, response.status, response.data.message)
            });
    };
    const handleSubmit = (event) => {
        event.preventDefault();
        setLoading(true);
        let formdata = new FormData();
        formdata.append("title", portfolio.title);
        formdata.append("title_ar", portfolio.title_ar ?? '');
        formdata.append("slug", portfolio.slug);
        formdata.append("description", portfolio.description ?? '');
        formdata.append("description_ar", portfolio.description_ar ?? '');
        formdata.append("external_link", portfolio.external_link ?? '');
        formdata.append("service_id", portfolio.service_id ?? 0);
        formdata.append("image", image);
        formdata.append("id", portfolioId);
        axios("admin/portfolio_update", {
            method: "POST",
            data: formdata,
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: "Bearer " + JSON.parse(localStorage.getItem("data")),
            },
        })
            .then((response) => {
                if (response.status === 200) {
                    setLoading(false);
                    ErrorHandler(alert, response.status, response.data.message);
                    history.push({
                        pathname: "/portfolio",
                        state: { data: true },
                    });
                } else {
                    setLoading(false);
                    ErrorHandler(alert, response.status, response.data.message)
                }
            })
            .catch(({ response }) => {
                setLoading(false);
                ErrorHandler(alert, response.status, response.data.message)
            });
    };
    const getServices = () => {
        axios("admin/get_services", {
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                Authorization: "Bearer " + JSON.parse(localStorage.getItem("data")),
            },
        })
            .then((response) => {
                console.log(response);
                if (response.status === 200) {
                    response.data.data.unshift({ name: 'No Services', value: '0' });
                    setServices(response.data.data);
                    setLoading(false);
                }
            })
            .catch(({ response }) => {
                setLoading(false);
            });
    };
    return (
        <div class="container-fluid">
            <div role="presentation">
                <Breadcrumbs aria-label="breadcrumb">
                    <BLink underline="hover" color="inherit" href="/">
                        Home
                    </BLink>
                    <BLink
                        underline="hover"
                        color="inherit"
                        href="/portfolio"
                    >
                        Portfolio
                    </BLink>
                    <BLink
                        underline="hover"
                        color="text.primary"
                        href="/"
                        aria-current="page"
                    >
                        Edit Portfolio
                    </BLink>
                </Breadcrumbs>
                <hr></hr>
            </div>
            <div class="container-fluid  mt-5">
                <div className="row">
                    <div className="col-md-12">
                        {Object.keys(portfolio).length != 0 && (
                            <form method="POST" className="blog-form">
                                <h3 className="edit-title">Edit Portfolio <i class="fi fi-rr-file-edit"></i></h3>
                                <hr></hr>
                                <Grid container spacing={2}>

                                    <Grid item xs={6}>
                                        <SelectSearch options={services} id="service_id" value={portfolio.service_id} onChange={(e) => setPortfolio({
                                            ...portfolio,
                                            service_id: e,
                                        })}
                                            name="service_id" search fuzzySearch placeholder="Choose Service Type" />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField id="outlined-basic" fullWidth label="external_link" variant="outlined" onChange={(e) => setPortfolio({
                                            ...portfolio,
                                            external_link: e.target.value,
                                        })} value={portfolio.external_link} name="external_link" />
                                    </Grid>

                                    {/* <Grid item xs={6}>
                                        <TextField id="outlined-basic" fullWidth label="Slug" variant="outlined" onChange={(e) => setPortfolio({
                                            ...portfolio,
                                            slug: e.target.value,
                                        })} value={portfolio.slug} name="slug" />
                                    </Grid> */}
                                    <Grid item xs={6}>
                                        <TextField id="outlined-basic" fullWidth label="Name" variant="outlined" onChange={(e) => setPortfolio({
                                            ...portfolio,
                                            title: e.target.value,
                                        })} value={portfolio.title} name="title" />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField id="outlined-basic" fullWidth label="Name Arabic" variant="outlined" onChange={(e) => setPortfolio({
                                            ...portfolio,
                                            title_ar: e.target.value,
                                        })} value={portfolio.title_ar} name="title_ar" />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <label className="label-description">
                                            Description<br></br>
                                            <TextEditor defaultValue={portfolio.description} onChange={(e) => setPortfolio({
                                                ...portfolio,
                                                description: e,
                                            })} />
                                        </label>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <label className="label-description">
                                            Description Arabic<br></br>
                                            <TextEditor defaultValue={portfolio.description_ar} onChange={(e) => setPortfolio({
                                                ...portfolio,
                                                description_ar: e,
                                            })} />
                                        </label>
                                    </Grid>


                                    <Grid item xs={6} >
                                        <Button
                                            component="label"
                                            role={undefined}
                                            variant="contained"
                                            tabIndex={-1}
                                            startIcon={<CloudUploadIcon />}
                                        >
                                            Upload
                                            <VisuallyHiddenInput type="file" onChange={(e) => setImage(e.target.files[0])} />
                                        </Button>

                                        <div className="img-container pt-2">
                                            <img src={portfolio.image} style={{ maxWidth: '100%', width: '200px', height: '100px' }}
                                            ></img>
                                        </div>
                                    </Grid>
                                    <Grid item xs={6} >
                                        <Button
                                            component="label"
                                            role={undefined}
                                            variant="contained"
                                            tabIndex={-1}
                                            startIcon={<CloudUploadIcon />}
                                        >
                                            Upload(Arabic)
                                            <VisuallyHiddenInput type="file" onChange={(e) => setImageAr(e.target.files[0])} />
                                        </Button>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <button type="button" onClick={handleSubmit} className="btn btn-primary  "><i class="fi fi-rr-refresh"></i> Update</button>
                                    </Grid>
                                </Grid>
                            </form>
                        )}
                    </div>
                </div>
            </div>
            <div class="container-fluid  mt-5">
                <Seo page={'Portfolio'} pageId={portfolioId}></Seo>
            </div>
        </div>
    );
}
export default EditPortfolio;